import { render } from "./DialogCallback.vue?vue&type=template&id=12c5983c&scoped=true"
import script from "./DialogCallback.vue?vue&type=script&lang=js"
export * from "./DialogCallback.vue?vue&type=script&lang=js"

import "./DialogCallback.vue?vue&type=style&index=0&id=12c5983c&scoped=true&lang=css"

import exportComponent from "/Users/raulbajmuhametov/work/vue/grany/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12c5983c"]])

export default __exports__